export class Participant {
	ID: number = 0;
	ConversationID: number = 0;
	UserID: number = 0;
	TimeStamp: Date = new Date();

	constructor(data?: any) {
		if (!data) return;
		this.ID = data.ID;
		this.ConversationID = data.ConversationID;
		this.UserID = data.UserID;
		this.TimeStamp = new Date(data.TimeStamp * 1000);

	}

}